import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { ApiResponseType } from '../types/ApiResponseTypes';
import request from './request';

interface useLoadDataResult {
  isLoading: boolean;
  response: ApiResponseType;
}

export const useLoadData = (
  getQuery: (userId, extraQueryParams, session?: string) => string,
  extraQueryParams?: unknown[]
): useLoadDataResult => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [response, setResponse] = useState<ApiResponseType>({
    errors: null,
    data: { user: null },
  });

  useEffect(() => {
    const userId =
      typeof window !== 'undefined' && window.localStorage.getItem('userId');

    const session =
      typeof window !== 'undefined' && window.localStorage.getItem('session');

    const loadData = async () => {
      try {
        const res = await request(getQuery(userId, extraQueryParams, session));

        if (res.errors && res.errors[0].message !== 'Forbidden') {
          toast.error(res.errors[0].message);
        } else {
          setResponse(res);
        }
      } catch (error) {
        toast.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  return { isLoading, response };
};
